<template>
  <div class="page">
    <c-source-detail
      :columns="columns"
      :data="data"
      resource="after_sales"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class AftersalesShow extends Vue {
  data = {}

  get columns() {
    return createColumns.call(this, {
      actionColumn: { detail: false }
    });
  }

  async fetchData() {
    this.data = await this.$request.get(`/after_sales/${this.$route.params.id}`)
  }

  async mounted() {
    this.fetchData();
  }
}
</script>

<style lang="scss" scoped>
  .box-order-item {
    margin-bottom: 20px;
    border-left: 1px solid $border-light;
    border-right: 1px solid $border-light;
  }
</style>

